export const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);

export const depureString = (str) => str.replace(/[^a-zA-Z ]/g, '').replace(/\s+/g, '');
